<template>
  <div>
    <b-btn v-if="$auth.user().isAdmin" @click="showAll = !showAll">показать все поля</b-btn>
    <vue-form-generator ref="form" :schema="schema" :model="model" :options="formOptions"> </vue-form-generator>
    <div v-if="!model.user_id && !$auth.user().isAdmin && objectsWithSubstance && objectsWithSubstance.length > 0">
      Заменить вещество {{ substance.name }} на создаваемую копию у объектов:
      <b-form-checkbox-group
        v-model="model.replaceIds"
        :options="objectsWithSubstance"
        class="mb-3"
        value-field="data"
        text-field="name"
      ></b-form-checkbox-group>
    </div>
    <b-button
      v-if="model.user_id == $auth.user().profile.user_id || $auth.user().isAdmin || !model.id"
      href="#"
      variant="success"
      @click="
        validate()
          .then((errorsData) => {
            if (errorsData.length) return;
            $emit('save', model);
          })
          .catch((err) => {
            consoleErr(err);
          })
      "
      ><span v-if="model.id">Сохранить</span><span v-else>Создать</span></b-button
    >
    <b-btn class="pull-right" @click="submitForm()" v-if="model.id" variant="success">Создать копию</b-btn>
  </div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";

const TTTYPE_SPG = 1;
const TTTYPE_SUG = 2;
const TTTYPE_NONE = 6;

const MODAL_DEFAULTS = { tttype: TTTYPE_NONE };

export default {
  name: "Gas",
  components: {
    "vue-form-generator": VueFormGenerator.component,
  },
  props: {
    objectSubstances: Array,
    substance: Object,
    validator: Object,
  },
  computed: {
    objectsWithSubstance() {
      var objects = [];
      if (this.objectSubstances && this.substance) {
        var objs = this.objectSubstances.find((el) => el.id == this.substance.id);
        if (objs) {
          for (var obj of objs.objects) {
            objects.push({ name: obj.name, data: { objId: obj.id, type: obj.type } });
          }
        }
      }
      return objects;
    },
  },
  watch: {
    substance() {
      this.model = Object.assign({}, MODAL_DEFAULTS, this.substance);
      this.$set(this.model, "replaceIds", []);
      if (this.objectsWithSubstance) {
        for (let obj of this.objectsWithSubstance) {
          this.model.replaceIds.push(obj.data);
        }
      }
    },
    validator() {
      this.$set(this.model, "validator", this.validator);
      this.$refs.form.validate();
    },
  },
  methods: {
    async validate() {
      return await this.$refs.form.validate();
    },
    consoleErr(data) {
      console.error(data);
    },
    submitForm() {
      this.validate()
        .then((errorsData) => {
          if (errorsData.length) return;
          this.model.parentId = this.model.id;
          this.model.id = null;
          this.model.name = this.model.name + " (копия)";
          this.model.user_id = this.$auth.user().profile.user_id;
          this.$emit("save", this.model);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {
    this.model = Object.assign({}, MODAL_DEFAULTS, this.substance);
    this.$set(this.model, "replaceIds", []);
    if (this.objectsWithSubstance) {
      for (let obj of this.objectsWithSubstance) {
        this.model.replaceIds.push(obj.data);
      }
    }
  },

  data() {
    return {
      showAll: false,
      model: {},
      schema: {
        groups: [
          {
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "Название",
                model: "name",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Название"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Молярная масса, кг*кмоль^(-1)",
                model: "M",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Молярная масса"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "НКПР, %(об)",
                model: "Cnkpr",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "НКПР"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Класс чувствительности",
                model: "class_of_combustible_substance",
                validator(value, field, model) {
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Корректировочный параметр",
                model: "param_B",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Корректировочный параметр"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Критическая температура, С",
                model: "Tkrit",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Критическая температура"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Критическое давление, МПа",
                model: "Pkrit",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Критическое давление"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Показатель адиабаты газа",
                model: "gamma",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Показатель адиабаты газа"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "select",
                selectOptions: {
                  hideNoneSelectedText: true,
                },
                label: "Тип в соответсвии с таблицей П3.4 приказа 404",
                model: "tttype",
                required: true,
                values: function () {
                  return [
                    { id: TTTYPE_NONE, name: "Нет" },
                    { id: TTTYPE_SPG, name: "СПГ" },
                    { id: TTTYPE_SUG, name: "СУГ (пропан-бутан)" },
                  ];
                },
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Тип"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Плотность жидкой фазы, кг/м3",
                model: "rho_L",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Плотность жидкой фазы"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  return [TTTYPE_SPG, TTTYPE_SUG].includes(model.tttype) || this.$parent.showAll;
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Температура кипения, С",
                model: "Tkip",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Температура кипения"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  return [TTTYPE_SPG, TTTYPE_SUG].includes(model.tttype) || this.$parent.showAll;
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Удельная теплоемкость, Дж/(кг*К)",
                model: "Cp",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Удельная теплоемкость"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  return [TTTYPE_SPG, TTTYPE_SUG].includes(model.tttype) || this.$parent.showAll;
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Молярная теплота парообразования, Дж/моль",
                model: "MolarHeatOfVaporization_J_per_mol",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Молярная теплота парообразования"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  return [TTTYPE_SPG, TTTYPE_SUG].includes(model.tttype) || this.$parent.showAll;
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Константа антуана A",
                model: "A",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Константа антуана A"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  return [TTTYPE_SPG, TTTYPE_SUG].includes(model.tttype) || this.$parent.showAll;
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Константа антуана B",
                model: "B",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Константа антуана B"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  return [TTTYPE_SPG, TTTYPE_SUG].includes(model.tttype) || this.$parent.showAll;
                },
              },
              {
                type: "input",
                inputType: "number",
                label: "Константа антуана Ca",
                model: "Ca",
                required: true,
                validator(value, field, model) {
                  if (!value) return 'Необходимо заполнить поле "Константа антуана Ca"';
                  if (model.validator && model.validator[field.model]) {
                    return model.validator[field.model][0];
                  }
                },
                visible: function (model) {
                  return [TTTYPE_SPG, TTTYPE_SUG].includes(model.tttype) || this.$parent.showAll;
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
};
</script>
